module.exports = __webpack_public_path__ + "img/img-error-wallet@2x.2f6317c5.png";